import _classCallCheck from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getDefaultCurrentScope, getDefaultIsolationScope } from '../defaultScopes.js';
import { Scope } from '../scope.js';
import { isThenable } from '../utils/is.js';
import { getMainCarrier, getSentryCarrier } from '../carrier.js';

/**
 * This is an object that holds a stack of scopes.
 */
var AsyncContextStack = /*#__PURE__*/function () {
  function AsyncContextStack(scope, isolationScope) {
    _classCallCheck(this, AsyncContextStack);
    var assignedScope;
    if (!scope) {
      assignedScope = new Scope();
    } else {
      assignedScope = scope;
    }
    var assignedIsolationScope;
    if (!isolationScope) {
      assignedIsolationScope = new Scope();
    } else {
      assignedIsolationScope = isolationScope;
    }

    // scope stack for domains or the process
    this._stack = [{
      scope: assignedScope
    }];
    this._isolationScope = assignedIsolationScope;
  }

  /**
   * Fork a scope for the stack.
   */
  return _createClass(AsyncContextStack, [{
    key: "withScope",
    value: function withScope(callback) {
      var _this = this;
      var scope = this._pushScope();
      var maybePromiseResult;
      try {
        maybePromiseResult = callback(scope);
      } catch (e) {
        this._popScope();
        throw e;
      }
      if (isThenable(maybePromiseResult)) {
        // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then(function (res) {
          _this._popScope();
          return res;
        }, function (e) {
          _this._popScope();
          throw e;
        });
      }
      this._popScope();
      return maybePromiseResult;
    }

    /**
     * Get the client of the stack.
     */
  }, {
    key: "getClient",
    value: function getClient() {
      return this.getStackTop().client;
    }

    /**
     * Returns the scope of the top stack.
     */
  }, {
    key: "getScope",
    value: function getScope() {
      return this.getStackTop().scope;
    }

    /**
     * Get the isolation scope for the stack.
     */
  }, {
    key: "getIsolationScope",
    value: function getIsolationScope() {
      return this._isolationScope;
    }

    /**
     * Returns the topmost scope layer in the order domain > local > process.
     */
  }, {
    key: "getStackTop",
    value: function getStackTop() {
      return this._stack[this._stack.length - 1];
    }

    /**
     * Push a scope to the stack.
     */
  }, {
    key: "_pushScope",
    value: function _pushScope() {
      // We want to clone the content of prev scope
      var scope = this.getScope().clone();
      this._stack.push({
        client: this.getClient(),
        scope: scope
      });
      return scope;
    }

    /**
     * Pop a scope from the stack.
     */
  }, {
    key: "_popScope",
    value: function _popScope() {
      if (this._stack.length <= 1) return false;
      return !!this._stack.pop();
    }
  }]);
}();
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */
function getAsyncContextStack() {
  var registry = getMainCarrier();
  var sentry = getSentryCarrier(registry);
  return sentry.stack = sentry.stack || new AsyncContextStack(getDefaultCurrentScope(), getDefaultIsolationScope());
}
function withScope(callback) {
  return getAsyncContextStack().withScope(callback);
}
function withSetScope(scope, callback) {
  var stack = getAsyncContextStack();
  return stack.withScope(function () {
    stack.getStackTop().scope = scope;
    return callback(scope);
  });
}
function withIsolationScope(callback) {
  return getAsyncContextStack().withScope(function () {
    return callback(getAsyncContextStack().getIsolationScope());
  });
}

/**
 * Get the stack-based async context strategy.
 */
function getStackAsyncContextStrategy() {
  return {
    withIsolationScope: withIsolationScope,
    withScope: withScope,
    withSetScope: withSetScope,
    withSetIsolationScope: function withSetIsolationScope(_isolationScope, callback) {
      return withIsolationScope(callback);
    },
    getCurrentScope: function getCurrentScope() {
      return getAsyncContextStack().getScope();
    },
    getIsolationScope: function getIsolationScope() {
      return getAsyncContextStack().getIsolationScope();
    }
  };
}
export { AsyncContextStack, getStackAsyncContextStrategy };